import axios from "axios";

// Ordine di risoluzione della baseURL (dal piu' specifico al piu' generico):
// 1. `PROXY_TARGET`/dev-proxy attivo (src/setupProxy.js + REACT_APP_HAS_DEV_PROXY=1):
//    path relativi cosi' il dev-server CRA inoltra `/api/*` al backend
//    mantenendo same-origin (necessario per HttpOnly cookies con SameSite=Lax).
// 2. `REACT_APP_BACKEND_URL` esplicito (preview Emergent, LAN, staging).
// 3. Fallback vuoto: build servito dal backend → same-origin nativo.
const HAS_DEV_PROXY = !!process.env.REACT_APP_HAS_DEV_PROXY;
const BACKEND_URL =
  process.env.NODE_ENV === "production" || HAS_DEV_PROXY
    ? ""
    : (process.env.REACT_APP_BACKEND_URL || "");

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// D2-A · Interceptor globale che rileva 401 session_idle_timeout / session_logout /
// session_admin_revoke / session_password_change, memorizza il motivo in
// sessionStorage (per Login page) e dispatcha un evento custom che
// l'IdleSessionProvider ascolta per eseguire il logout locale.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    if (status === 401 && typeof detail === "string" && detail.startsWith("session_")) {
      const reason = detail.includes("idle") ? "idle_timeout" : "logout";
      try { sessionStorage.setItem("gi_login_reason", reason); } catch { /* noop */ }
      try {
        window.dispatchEvent(new CustomEvent("gi:session-terminated",
                                              { detail: { reason: detail } }));
      } catch { /* noop */ }
    }
    return Promise.reject(error);
  },
);

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return e?.message || "Errore imprevisto";
}
